import type { FC } from 'react';

const Home: FC<any> = () => <><div /></>;

export default Home;
